import { TCouponDetails } from '../../../S/pricing/types';
import { getRupeePercentagePrefix } from '../utils';

interface IPriceCardCoupon {
  coupon: TCouponDetails;
  setIsCopiedCB: (value: boolean) => void;
}

export const PriceCardCoupon: React.FC<IPriceCardCoupon> = ({
  coupon,
  setIsCopiedCB,
}) => {
  if (!coupon) return <></>;

  const couponCode = coupon.code;
  return (
    <button
      className="bg-blue-50 text-left border-2 w-full border-blue-350 border-dashed p-4 rounded-lg cursor-pointer sm:py-3 focus:outline-none"
      onClick={async () => {
        await navigator.clipboard.read();
        navigator.clipboard.writeText(couponCode);
        setIsCopiedCB(true);
      }}
      onMouseLeave={() => {
        setIsCopiedCB(false);
      }}
    >
      <p
        data-testid="price-card-coupon-header"
        className="text-font-500 font-semibold sm:text-s-18"
      >
        {`Get flat `}
        {getRupeePercentagePrefix(coupon.discountType, coupon.discountValue)}
        {' Off'}
      </p>
      <div className="flex items-center">
        <p
          data-testid="price-card-coupon-code"
          className="font-semibold w-11/12 text-base text-font-500 whitespace-nowrap overflow-hidden overflow-ellipsis"
        >
          Use Code: {couponCode}
        </p>
        <img
          src="https://assets1.cleartax-cdn.com/cleartax/images/1679988100_copy.png"
          className="w-1/12 self-center ml-2"
          height={18}
          alt={'copy'}
          width={18}
        ></img>
      </div>
    </button>
  );
};
